export enum SegmentStatusIcons {
  Submitted = 'Submitted',
  ContractorActionRequired = 'Contractor Action Required',
  AdditionalInformationRequested = 'Additional Information Requested',
  Compliant = 'Compliant',
  CurrentCertificationStillValid = 'Current Certification Still Valid',
  SubmittedAwaitingOthers = 'Submitted Awaiting Others',
  ResubmittedAwaitingOthers = 'Resubmitted Awaiting Others',
  DocumentExpired = 'Document Expired',
  CompliantAwaitingOthers = 'Compliant Awaiting Others',
  Failed = 'Failed',
  Expired = 'Expired',
  ReAssessmentRequired = 'Re-assessment Required',
  ReAssessmentSubmitted = 'Re-assessment Submitted'
}

export interface ISegmentStatus {
  id: string;
  displayOrder: number;
  documentExpired?: string;
  segmentType: string;
  subscriptionId: string;
  legacySubscriptionTypeId?: number;
  status: string;
  contractorStatus: SegmentStatusIcons;
  priority: number;
  verificationTypeId: string;
  segmentId: string;
  isActive: boolean;
}
